import React, {Component} from 'react';
import {connect} from 'react-redux';
import TopLevel from './TopLevel';
import _ from 'lodash';
import {SideNavInternal} from 'go/components/dynamic/layout/SideNavInternal';
import {isFemaOrProgramExternal, isFemaUser} from 'common/utils';
import {isSubApplicationConfig} from 'go/components/dynamic/modules/grantLandingPage/utils';

export class CommentsNavItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {baseClass, isActive, config, hasFemaPermissions} = this.props;
    const {configType} = config;
    const name = 'Comments';
    const configName = isSubApplicationConfig(configType) ? 'subComments' : 'comments';
    if (hasFemaPermissions) {
      return (
        <React.Fragment>
          <TopLevel
            name={name}
            baseClass={baseClass}
            handleClick={() => this.props.loadPageWithConfig(configName)}
            active={isActive}
            isExpandable={false}
          />
          {isActive && config && config.configType === configName && (
            <React.Fragment>
              <SideNavInternal
                navToSpecificLocation={() => {
                  /* this is the key to making the sidenav active state work
                          don't use until figuring out how to incorporate VisibilitySensor into this
                        */
                }}
                location={this.props.location}
                title={`${name} Navigation`}
                startingIndentLevel={1}
                {...config.payload}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({});

export const mapStateToProps = (state) => {
  return {
    hasFemaPermissions: isFemaOrProgramExternal(state.auth.permissions),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsNavItem);
